import DateTimeCondition from './DateTimeCondition.vue';
import TextCondition from './TextCondition.vue';
import DecimalCondition from './DecimalCondition.vue';
import NumberCondition from './NumberCondition.vue';
import ListCondition from './ListCondition.vue';
import DurationCondition from './DurationCondition.vue';
import IntentCondition from '@/features/bots/components/designer/Conditions/IntentCondition.vue';
import TimeOfDayCondition from './TimeOfDayCondition.vue';

export const ConditionComponents = {
  DateTimeCondition,
  TextCondition,
  DecimalCondition,
  NumberCondition,
  ListCondition,
  DurationCondition,
  IntentCondition,
  TimeOfDayCondition,
};

export type ConditionComponentType = keyof typeof ConditionComponents;
